'use client'

import Image from 'next/image'
import { alpha } from '@mui/material/styles'
import { Box } from '@mui/material'

// Types
import type { FramedImageProps } from '@/types/components/atoms/image/framed'

// Photo in a rounded frame that fills it (object-fit cover), with a slight color grade and a slow zoom on hover
const FramedImageAtom = (props: FramedImageProps) => {
	// Props
	const { src, alt, height, radius = 6, tint = true, sx, sizes = '(max-width: 900px) 100vw, 50vw', priority } = props

	return (
		<Box
			sx={{
				position: 'relative',
				width: 1,
				height,
				borderRadius: radius,
				overflow: 'hidden',
				'& img': {
					objectFit: 'cover',
					filter: 'saturate(1.08) contrast(1.04)',
					transition: 'transform 1.2s cubic-bezier(0.22, 1, 0.36, 1)'
				},
				'&:hover img': { transform: 'scale(1.06)' },
				...(tint && {
					'&::after': {
						content: '""',
						position: 'absolute',
						inset: 0,
						background: t => `linear-gradient(160deg, ${alpha(t.palette.primary.main, 0.18)} 0%, transparent 45%, ${alpha('#000', 0.18)} 100%)`,
						pointerEvents: 'none'
					}
				}),
				...sx
			}}
		>
			<Image src={src} alt={alt} fill sizes={sizes} priority={priority} />
		</Box>
	)
}

export default FramedImageAtom
